import { Pencil, Trash2 } from 'lucide-react'
import './PanelAdminCRUD.css'

// Patrón compartido de Fase B (Bloque 3.3): bloque de alta arriba (línea
// fina, estilo sidebar) + listado tabulado abajo (estilo Bandeja de
// reportes). El form de alta lo arma cada pantalla (varían mucho entre
// sí: checkboxes, textarea, selector de tipo...), este componente solo
// pone el layout y la tabla con acciones por fila.
export default function PanelAdminCRUD({ formulario, columnas, filas, claveFila = 'id', onFilaClick, onEditar, onEliminar, puedeEliminar, accionesExtra, vacioTexto = 'Todavía no hay nada acá.' }) {
  return (
    <div className="panel-admin-crud">
      <div className="panel-admin-alta">
        {formulario}
      </div>
      {filas.length === 0 ? (
        <p className="panel-admin-vacio">{vacioTexto}</p>
      ) : (
        <div className="panel-admin-tabla-wrap">
          <table className="panel-admin-tabla">
            <thead>
              <tr>
                {columnas.map(c => <th key={c.key}>{c.label}</th>)}
                <th></th>
              </tr>
            </thead>
            <tbody>
              {filas.map(fila => (
                <tr
                  key={fila[claveFila]}
                  className={onFilaClick ? 'panel-admin-fila-clickable' : undefined}
                  onClick={onFilaClick ? () => onFilaClick(fila) : undefined}
                >
                  {columnas.map(c => <td key={c.key}>{c.render ? c.render(fila) : fila[c.key]}</td>)}
                  <td className="panel-admin-acciones" onClick={e => onFilaClick && e.stopPropagation()}>
                    {accionesExtra?.(fila)}
                    {onEditar && (
                      <button className="panel-admin-btn-editar" onClick={() => onEditar(fila)} title="Editar" aria-label="Editar">
                        <Pencil size={16} strokeWidth={2} />
                      </button>
                    )}
                    {onEliminar && (!puedeEliminar || puedeEliminar(fila)) && (
                      <button className="admin-btn-eliminar" onClick={() => onEliminar(fila)} title="Eliminar" aria-label="Eliminar">
                        <Trash2 size={16} strokeWidth={2} />
                      </button>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  )
}
